import { render } from "./NewsForm.vue?vue&type=template&id=9842d692&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./NewsForm.vue?vue&type=style&index=1&id=9842d692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9842d692"]])

export default __exports__